module.exports = __webpack_public_path__ + "static/media/foodomov.84fc16cc.mp4";